import { createSelector } from '@opengov/compose-app/reselect';
import React from 'react';

import { ICreateCompositeMapping, IMultiCompositeMapping } from './types';

export const createComposite: ICreateCompositeMapping = (component, selector) => ({ component, selector });

export function getComponent(compositeMapping) {
  return metaData => {
    if (metaData && !!metaData.type && compositeMapping[metaData.type]) {
      const Component = compositeMapping[metaData.type].component;
      const componentProps = metaData.props;
      return <Component {...componentProps} />;
    } else {
      return null;
    }
  };
}

export function buildSelector(selectCompositeType, additionalProps, compositeMapping) {
  return createSelector(
    state => state,
    selectCompositeType,
    (state, compositeType: string) => {
      return !!compositeType && compositeMapping[compositeType]
        ? {
            type: compositeType,
            props: {
              ...compositeMapping[compositeType].selector(state),
              ...additionalProps
            }
          }
        : null;
    }
  );
}

export function createCompositeMap(selectCompositeType, additionalProps, compositeMapping: IMultiCompositeMapping) {
  return {
    component: getComponent(compositeMapping),
    selector: buildSelector(selectCompositeType, additionalProps, compositeMapping)
  };
}
